import React from 'react';

import html2pdf from 'html2pdf.js';

import { Button, Tooltip } from '@lucidhq/lucidium';
import { DownloadIcon } from '@lucidhq/lucidium/icons';

import { t } from '~/utils/i18n';

import { useCampaignManager } from '../../CampaignManagerProvider';

export const EXPORT_PREVIEW_ID = 'review-campaign';

export const ExportPreview = () => {
  const { managedCampaign } = useCampaignManager();

  const onClick = () => {
    const node = document.querySelector(
      `#${EXPORT_PREVIEW_ID}`
    ) as HTMLElement | null;
    if (!node) return;

    const originalWidth = node.offsetWidth;
    const originalHeight = node.offsetHeight;
    const fudgeHeight = originalHeight + 50; // Prevent extra blank page in PDF caused by layout overflow

    html2pdf()
      .set({
        margin: 24,
        filename: `review-campaign-${managedCampaign?.details.campaign_id}.pdf`,
        html2canvas: {
          scale: 2
        },
        jsPDF: {
          unit: 'px',
          format: [originalWidth, fudgeHeight],
          orientation: 'portrait'
        },
        pagebreak: { mode: ['avoid-all'] }
      })
      .from(node)
      .save();
  };

  return (
    <Tooltip title={t('campaignManager.review.header.export')}>
      <Button
        type="button"
        onClick={onClick}
        lss={{
          display: 'flex',
          alignItems: 'center',
          py: 'sm'
        }}
      >
        <DownloadIcon size={20} lss={{ mr: 'md' }} />{' '}
        {t('campaignManager.review.header.export')}
      </Button>
    </Tooltip>
  );
};
